export default __webpack_public_path__ + "static/media/IndependenceNew6.d098ad86.JPG";